import * as Yup from "yup";

export const formikCreateApplication = {
    initialValues: {
        title : "",
        patientId : null,
        stages : [],
        documents : [],
        pdfFormIds: [],
        documentId : [],
        stateOfResidence : {},
        stateId: "",
        age: 0,
        householdIncome: 0,
        eligiblityGroup: "",
        signers:[],
        workflowId: "",
        signerName: "",
        signerEmail: "",
        formToSignedId : "",
        formToSigned : "",
        signerNew:"",
        applicationType : {}
    }
};

export const columnApplicationOptions = [
  { value: "title", label: "Application Title", dataType: "Search_String", isEnum: false },
  { value: "patient_name", label: "Patient Name", dataType: "Search_String", isEnum: false },
  // { value: "type", label: "Application Type", dataType: "String", isEnum: true },
  { value: "created_at", label: "Created At", dataType: "Date", isEnum: false },
  { value: "assigned_to", label: "Assigned To", dataType: "String", isEnum: false },
  { value: "status", label: "Status", dataType: "String", isEnum: true },
  { value: "state", label: "Resident State", dataType: "String", isEnum: false },
  { value: "group_eligibility", label: "Eligibility Group", dataType: "String", isEnum: true }
];

const userRole = localStorage.getItem("userRole");

export const columnSupportOptions = [
  { value: "ticketId", label: "Ticket Id", dataType: "String", isEnum: false },
  { value: "title", label: "Support Title", dataType: "String", isEnum: false },
  { value: "requestType", label: "Request Type", dataType: "String", isEnum: true },
  { value: "status", label: "Status", dataType: "String", isEnum: true },
  { value: "createdAt", label: "Created At", dataType: "Date", isEnum: false },
  { value: "createdBy", label: "Created By", dataType: "String", isEnum: false },
  ...(userRole === "Platform"
    ? [
        { value: "category", label: "Category", dataType: "String", isEnum: false },
        { value: "priority", label: "Priority", dataType: "String", isEnum: false },
        { value: "assignedTo", label: "Assigned To", dataType: "String", isEnum: false },
        { value: "resolution", label: "Resolution", dataType: "String", isEnum: true }
      ]
    : [])
];

export const columnFilterSupportOptions = [
  { value: "ticketId", label: "Ticket Id", dataType: "Search_String", isEnum: false },
  { value: "title", label: "Support Title", dataType: "Search_String", isEnum: false },
  { value: "status", label: "Status", dataType: "String", isEnum: true },
  { value: "createdBy", label: "Created By", dataType: "String", isEnum: false },
  ...(userRole === "Platform"
    ? [
        { value: "assignedTo", label: "Assigned To", dataType: "String", isEnum: false }
      ]
    : [])
];

export const stageStatusOption = [
  { value: "NotStarted", label: "Not Started" },
  { value: "InProcess", label: "In Process" },
  { value: "Approved", label: "Approved" },
  { value: "NotApproved", label: "Not Approved" }
];

export const supportStatus = [
  { value: "InProgress", label: "InProgress" },
  { value: "Todo", label: "To Do" },
  { value: "Completed", label: "Completed" }
];

export const taskActionOptions = [
  { value: "Update Form", label: "Update Form" },
  { value: "Upload Document", label: "Upload Document" },
  { value: "Verify Form", label: "Verify Form" }
];

export const formikTasks = {
  initialValues: {
    patientId: null,
    assignTo: null,
    applicationId: null,
    dueDate: null,
    title: "",
    taskAction: "",
    documentId: null,
    formId: null,
    notes: ""
  },
  validationSchema: Yup.object().shape({
    patientId: Yup.string().required("Patient is required"),
    title: Yup.string().required("Title is required"),
    assignTo: Yup.string().required("Assign To is required"),
    applicationId: Yup.string().required("Application is required")
  })
};

export const formikAddApplicationForm = {
  initialValues: {
    formId: "",
    formType: "selectFromList",
    formTitle: "",
    pdfForm: {},
    signatureRequired: false
  },
  validationSchema: Yup.object().shape({
    formId: Yup.string().when("formType", {
      is: "selectFromList",
      then: (schema) =>  schema.required("Required field"),
      otherwise: (schema) => schema.nullable()
    }),
    formTitle: Yup.string().when("formType", {
      is: "selectFromList",
      then: (schema) => schema.nullable(),
      otherwise: (schema) => schema.required("Required field")
    }),
    pdfForm: Yup.mixed().when("formType", {
      is: "selectFromList",
      then: (schema) => schema.nullable(),
      otherwise: (schema) =>
        schema
          .required("A PDF file is required")
          .test(
            "fileFormat",
            "Only PDF files are allowed",
            (value) => value && value.type === "application/pdf"
          )
    }),
    signatureRequired: Yup.boolean()
  })
};

export const formikAddApplicationDoc = {
  initialValues: {
    docTitle : "",
    docFile : {},
    documentTypeId: "",
    documentId: ""
  },
  validationSchema: Yup.object().shape({
    docTitle: Yup.string().required("Document Title is required"),
    documentTypeId: Yup.string().required("Document Type is required")
  })
};

export const statusTaskOptions = [
  { value: "To Do", label: "To Do" },
  { value: "InProgress", label: "In Progress" },
  { value: "Pending", label: "Pending Verification" },
  { value: "Completed", label: "Completed" }
];

export const applicationStatus = [
  { value: "InProcess", label: "In Process" },
  { value: "Approved", label: "Approved" },
  { value: "NotApproved", label: "Not Approved" }
];

export const formikAddApplicationReceipt = {
  initialValues: {
    docTitle : "",
    documentType: '',
    docFile : {}
  },
  validationSchema: Yup.object().shape({
    docTitle : Yup.string().required("Required field")
  })
};

export const formStatus = Object.freeze({
  TO_DO: "To Do",
  IN_PROGRESS: "InProgress",
  PENDING_VERIFICATION: "Pending Verification",
  READY_TO_SIGN: "Ready to sign",
  WAITING_FOR_SIGNATURE: "Waiting for signature",
  COMPLETED: "Completed"
});

export const formStatusArray = Object.values(formStatus);

export const statusFormOptions = [
  { value: "To Do", label: "To Do" },
  { value: "InProgress", label: "In Progress" },
  { value: "Pending Verification", label: "Pending Verification" },
  { value: "Ready to sign", label: "Ready to add signer" },
  { value: "Waiting for signature", label: "Waiting for signature" },
  { value: "Completed", label: "Completed" }
];

export const statusFormWithoutSignatureOptions = [
  { value: "To Do", label: "To Do" },
  { value: "InProgress", label: "In Progress" },
  { value: "Pending Verification", label: "Pending Verification" },
  { value: "Completed", label: "Completed" }
];
